<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="login-part d-flex align-center justify-center">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="login-part d-flex align-center justify-center flex-column" :class="backgroundClass"
            >
              <div class="login-wrapper dark" :class="loginWrapperBackgroundClass">
                <div class="d-flex justify-center align-center">
                  <!-- <h2>M -</h2> -->
                  <v-img
                    src="@/assets/Indobeauty.png"
                    max-width="200"
                    max-height="100"
                    contain
                    lazy-src="@/assets/empty-img.png"
                  ></v-img>
                </div>
                <v-form
                  ref="formLogin"
                  v-model="validFormLogin"
                  lazy-validation
                >
                  <v-container>
                    <v-row>
                      <!-- Kolom untuk Tipe Distributor, Username, dan Password -->
                      <v-col cols="12" md="7">
                        <v-row class="flex-column text-right">
                          <v-col cols="12">
                            <v-select
                              v-model="distCode"
                              :items="distributorCodeList"
                              item-text="distributorCode"
                              item-value="distributorCode"
                              label="Tipe Distributor"
                              outlined
                              required
                              hide-details="auto"
                              @change="handleUserType"
                              style="background-color: white; border-radius: 10px;"
                            ></v-select>
                            <v-text-field
                              v-model="email"
                              label="Username"
                              required
                              outlined
                              hide-details="auto"
                              :rules="emailRules"
                            ></v-text-field>
                            <v-text-field
                              v-model="password"
                              :rules="passRules"
                              :type="value ? 'password' : 'text'"
                              label="Password"
                              required
                              outlined
                              hide-details="auto"
                              class="mb-0"
                              :append-icon="value ? 'mdi-eye-off' : 'mdi-eye'"
                              @click:append="() => (value = !value)"
                            ></v-text-field>
                            <v-row class="d-flex justify-end">
                              <v-btn
                                to="/forgot-password"
                                small
                                text
                                class="text-capitalize dark--text px-0 mt-1"
                              >
                                Forgot Password?
                              </v-btn>
                              
                              <!-- Teks baru yang dapat diklik di samping 'Forgot Password?' -->
                              <v-btn
                                to="/register"
                                small
                                text
                                class="text-capitalize dark--text px-0 mt-1 ml-2"
                              >
                                Register
                              </v-btn>
                            </v-row>
                          </v-col>

                          <!-- Button login dengan lebar penuh -->
                          <v-col class="d-flex justify-space-between">
                            <v-btn
                              class="text-capitalize rounded-lg"
                              large
                              block
                              @click="handleLogin"
                              color="black"
                            >
                              <span style="color: white;">Masuk</span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>

                      <!-- Kolom untuk Contact Us dan Privacy Policy -->
                      <v-col cols="12" md="4">
                        <v-row no-gutters justify="space-between" class="pl-4">
                          <v-col cols="12">
                            <v-row>
                              <v-col>
                                <p class="text-h6 font-weight-bold">Contact Us</p>
                                <p>
                                  <v-icon small color="dark">mdi-phone-outline</v-icon>
                                  +62 813-8443-7916
                                </p>
                                <p>
                                  <v-icon small color="dark">mdi-email-outline</v-icon>
                                  notification@indobeauty.com
                                </p>
                                    <v-tooltip bottom color="primary">
                                    <template v-slot:activator="{ on, attrs }">
                                      <p
                                        v-bind="attrs" v-on="on"
                                        class="text-h6 font-weight-bold"
                                        style="cursor: pointer;"
                                        @click="$router.push({name: 'privacyPolicy'})"
                                      >
                                        Privacy Policy
                                      </p>
                                    </template>
                                    <span>Klik Saya</span>
                                  </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <!-- Button untuk Register (responsive di bawah layar tertentu) -->
                    <v-row class="flex-column text-center">
                      <v-col class="py-0">
                        <v-btn
                          to="/registrasi-non-admf"
                          small
                          text
                          class="text-capitalize primary--text px-0 mt-1"
                          v-if="isExternalAgentType && isNonADMF"
                        >
                          Don't have account? Register now
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>

                </v-form>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="showSnackbar" :color="snackbarColor">
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn text small v-bind="attrs" @click="showSnackbar = false">
          X
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :absolute="absolute" :value="isLoading">
      <v-progress-circular indeterminate color="primary"> </v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
// import Captcha from "@/components/Captcha/Captcha";
import { mapActions, mapState } from "vuex";
// import config from './config';

export default {
  name: "Login",
  components: {
    // captcha: Captcha,
  },
  data() {
    return {
      value: String,
      validFormLogin: true,
      absolute: true,
      email: "",
      emailRules: [
        (v) =>
          !!v ||
          `${
            this.isExternalAgentType ? `ID / Email` : `NIK`
          } tidak boleh Kosong`,
        // (v) => /.+@.+/.test(v) || "Format E-mail harus sesuai",
      ],
      createEmail: "",
      password: "",
      passRules: [(v) => !!v || "Password harus diisi"],
      userTypeRules: [(v) => !!v || "Tipe User harus diisi"],
      isCaptchaOk: false,
      distCode: '',
      distributorCodeList: [],
      backgroundClass: '',
      loginWrapperBackgroundClass:''
    };
  },
  methods: {
    ...mapActions(["login", "getFeatures", "getUserType", 'getDistributor', 'getVA']),
    handleLogin() {
      if (this.distCode == null || this.distCode == '') {
        this.$store.commit("setShowSnackbar", {
          snackbarMsg: "Distributor harus di isi",
          snackbarColor: "red",
        });
        return
      }
      if (this.$refs.formLogin.validate() ) {
        this.$store.commit("setDistType", this.distCode);

        this.getDistributor({distributorCode: this.distCode})
        .then((response) => {
          if (response.data.status == 1) {
            this.$store.commit("setDistTypeList", response.data.data);

            this.login({ username: this.email, password: this.password, distCode: this.distCode })
              .then((response) => {
                if (response.data.status == 1) {
                  this.$router.push({ name: "dashboard" });
                } else {
                  this.$store.commit("setShowSnackbar", {
                    snackbarMsg: response.data.message,
                    snackbarColor: "red",
                  });
                  // this.$root.$refs.A.picture();
                }
              })
              .catch((err) => {
                this.$helpers.handleError(err);
                // this.$root.$refs.A.picture();
              });

          }else{
            this.$store.commit("setShowSnackbar", {
              snackbarMsg: response.data.message,
              snackbarColor: "red",
            });
            // this.$root.$refs.A.picture();
          }
        })
        
      }
    },
    handleUserType: function(val) {
      this.$store.commit("setDistType", 
        val
      );
      if (this.distType == this.$constant.DIST_SMA) {
        this.$vuetify.theme.themes.light.primary = '#FAAC1B'; // kuning
        this.backgroundClass = 'bg-yellow-sma-andalan'; // jika username A
        this.loginWrapperBackgroundClass = 'bg-login-wrapper-sma';
      }else{
        this.$vuetify.theme.themes.light.primary = '#FCB3C5'; // kuning
        this.backgroundClass = 'bg-pink-smg-sdn'
        this.loginWrapperBackgroundClass = 'bg-login-wrapper-smg-sdn';
      }
      // console.log("masuk pak eko: "+this.distType)
    },
    captchaOk() {
      this.isCaptchaOk = true;
    },
    captchaNotOk() {
      this.isCaptchaOk = false;
    },
    getListDistributor(){
      this.getDistributor({distributorCode: ''})
      .then((response) => {
        if (response.data.status == 1) {
          this.distributorCodeList = response.data.data;
          
        }
      })
    }
  },
  created() {
    // this.getUserType();
    this.$store.commit("setDistType", 
        'SMG'
      );
    if (this.distType == this.$constant.DIST_SMA) {
      this.$vuetify.theme.themes.light.primary = '#FAAC1B'; // kuning
      this.backgroundClass = 'bg-yellow-sma-andalan'; // jika username A
      this.loginWrapperBackgroundClass = 'bg-login-wrapper-sma';
    }else{
      this.backgroundClass = 'bg-pink-smg-sdn'
      this.loginWrapperBackgroundClass = 'bg-login-wrapper-smg-sdn';
    }
    this.getListDistributor();
  },
  computed: {
    ...mapState(["isLoading", "userTypeListWeb", 'distTypeList','distType']),
    isExternalAgentType() {
      return this.userType != "INTERN_SLS";
    },
    isNonADMF() {
      return this.userType == "NON_ADMF";
    },
    showSnackbar: {
      get: function() {
        return this.$store.getters.showSnackbar;
      },
      set: function() {
        this.$store.commit("hideSnackBar");
      },
    },
    snackbarMsg: {
      get: function() {
        return this.$store.getters.snackbarMsg;
      },
      set: function() {
        this.$store.commit("resetSnackBarMsg");
      },
    },
    snackbarColor: {
      get: function() {
        return this.$store.getters.snackbarColor;
      },
      set: function() {
        this.$store.commit("resetSnackBarColor");
      },
    },
  },
};
</script>

<style scoped src="./Login.scss" lang="scss" />
